import { screenToWorldCoordinate } from '@/GraphEditor/drawingLayer/helpers/coordinateSystemMapping';

export function getViewPortCenterFromGraphContainer(graphContainerElement: HTMLDivElement, zoomLevel: number) {
    return screenToWorldCoordinate(
        { x: graphContainerElement.clientWidth / 2, y: graphContainerElement.clientHeight / 2 },
        {
            x: graphContainerElement.scrollLeft,
            y: graphContainerElement.scrollTop,
        },
        zoomLevel,
    );
}
